import 'react';
import { deprecatedComponent } from '../core/deprecated-component.js';
import 'tiny-warning';
import { SecondaryTileCallouts } from './secondary-tile-callouts.component.js';
export { SecondaryTileCallouts } from './secondary-tile-callouts.component.js';
export { SecondaryTileContents } from './secondary-tile-contents.component.js';
export { SecondaryTileDescription } from './secondary-tile-description.component.js';
export { SecondaryTileImage } from './secondary-tile-image.component.js';
export { SecondaryTileLabeledInputButton } from './secondary-tile-labeled-input-button.component.js';
export { SecondaryTileLabeledInputLabel } from './secondary-tile-labeled-input-label.component.js';
export { SecondaryTileLabeledInput } from './secondary-tile-labeled-input.component.js';
export { SecondaryTileNameWithPrice } from './secondary-tile-name-with-price.component.js';
export { SecondaryTileName } from './secondary-tile-name.component.js';
export { SecondaryTilePrice } from './secondary-tile-price.component.js';
export { SecondaryTile } from './secondary-tile.component.js';
export { SecondaryTileLabeledInputContext, useSecondaryTileLabeledInputContext } from './secondary-tile.context.js';
const SecondaryTileBadges = deprecatedComponent({
  displayName: 'SecondaryTileBadges',
  root: SecondaryTileCallouts,
  description: 'Use SecondaryTileCallouts component Instead'
}) /* PLOP_COMPONENT_EXPORT_IN_INDEX */;

export { SecondaryTileBadges };